import React, { useState } from 'react';
import { useIndexedDB } from 'react-indexed-db';
import { OfflineModeContext } from '../../libs/constants/offlineEnhanced';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import DeleteConfirmationModal from '../../components/DeleteConfirmationModal';
import { toolTips } from '../../utils/toolTips';
import OfflineModeBody from './components/OfflineModeBody/OfflineModeBody';
import OfflineModeModals from './components/OfflineModeModals';
import OfflineModeHeader from './components/OfflineModeHeader';

const OfflineEnhancedLayout = () => {
  const [isResetModalVisible, toggleResetModalVisibility] = useState(false);

  const clearDB = () => {
    const db = useIndexedDB('Signatures');
    db.clear();
  };

  return (
    <OfflineModeContext.Consumer>
      {(value) => {
        const {
          customerListFetchStatus,
          jobsListFetchStatus,
          teamList,
          reportTemplateList,
          deviceList,
          innerDeviceList,
          partList,
          reportListByJobIds,
          reportListByCustomer,
          uploadSignature,
          questionJsonDefaultReports,
        } = value.offlineMode;
        const { employeeDetails } = value;
        const { reportUpdate } = value;
        let signUrl = null;
        if (employeeDetails && employeeDetails.inspectorSignature && employeeDetails.inspectorSignature.url) {
          signUrl = employeeDetails.inspectorSignature.url;
        }
        return (
          <div>
            {(customerListFetchStatus.isFetching ||
              jobsListFetchStatus.isFetching ||
              teamList.isFetching ||
              reportTemplateList.isFetching ||
              deviceList.isFetching ||
              innerDeviceList.isFetching ||
              partList.isFetching ||
              reportListByJobIds.isFetching ||
              reportListByCustomer.isFetching ||
              reportUpdate.isfetching ||
              questionJsonDefaultReports.isFetching ||
              (uploadSignature && uploadSignature.isFetching)) && <Loader />}
            <OfflineModeModals />
            {isResetModalVisible && (
              <DeleteConfirmationModal
                deleteMessage="Are you sure you want to reset offline data?"
                deleteButtonText="Reset"
                headingMessage="Confirm Reset"
                handleClickDelete={() => {
                  value.resetOfflineReducer();
                  toggleResetModalVisibility(false);
                  clearDB();
                }}
                handleClickCross={() => toggleResetModalVisibility(false)}
                handleClickCancel={() => toggleResetModalVisibility(false)}
              />
            )}
            <div>
              <Button
                className="mr-bt-20"
                text="Reset"
                color="#6AA14E"
                onBtnClick={() => toggleResetModalVisibility(true)}
                dataFor="offline-reset-button"
                dataTip={toolTips.offline.reset}
                place="right"
              />
            </div>
            <div className="card">
              <OfflineModeHeader />
              <OfflineModeBody />
            </div>
            {/* Icons, SVG, Img for offline-mode */}
            <div style={{ visibility: 'hidden' }}>
              <img style={{ height: '0px' }} src={signUrl} alt="" />
              <div className="material-icon-wrapper">
                <span className="material-icons material-icon-tested">
                  check_circle
                </span>
                <span className="tested"></span>
              </div>
              <div
                className="imag-upload sprite-icon1"
                data-toggle="modal"
                data-target="#img-upload"
              ></div>
              <div className="work-list-icon">
                <div className="list-icon-wrap">
                  <div className="user-house sprite-icon-before1">
                    <div className="house-list-wrap">
                      <div className="house-list"></div>
                    </div>
                  </div>
                </div>
              </div>
              <span className="notes-icon-sprite-icon notes-header-icon-sprite-icon">
                <div id="pad-lt-0" className="Notes sprite-icon-before"></div>
              </span>
              <div className="qrcode-icon-sprite-icon">
                <span className="material-icons">qr_code_scanner</span>
              </div>
              <span
                className="edit-icon sprite-icon"
                style={{ top: '10px', marginRight: '0px', right: '40px' }}
                id="test-edit-span"
              ></span>
            </div>
          </div>
        );
      }}
    </OfflineModeContext.Consumer>
  );
};

export default OfflineEnhancedLayout;
